import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { useTranslations } from '@lang';
import { LockIcon } from '@root/styles/icons';

import SectionContainer from '@common/components/SectionContainer';
import ImgixWrapper from '@common/components/ImgixWrapper';

import { Link } from 'shared-routing';
import { Routes } from '@common/constants';

const StyledHeader = styled.header`
  position: relative;
  font-family: ${({ theme }) => theme.headerFont};
  background: ${({ theme }) => theme.headerColour || '#fff'};
  z-index: 10;
  padding: 12px 0 8px;
  border-bottom: ${({ theme }) => `1px solid ${theme.defaultColors.lighterGrey}`};

  margin-bottom: 20px;
`;

const StyledImageWrapper = styled.div`
  display: inline-block;
  a {
    display: block;
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CheckoutTitle = styled.p`
  display: flex;
  align-items: center;
  margin: 0;
  font-size: 15px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  font-family: ${({ theme }) => theme.bodyFont};

  span {
    margin-left: 5px;
  }
`;

const Header = ({ logo = null, name }) => {
  const { t } = useTranslations();

  return (
    <StyledHeader>
      <SectionContainer>
        <Row>
          {logo && (
            <StyledImageWrapper>
              <Link route={Routes.HOME}>
                <ImgixWrapper src={logo.url} height={42} alt={name} />
              </Link>
            </StyledImageWrapper>
          )}
          <CheckoutTitle>
            <LockIcon width="16" height="16" />
            {t('basket.secureCheckout')}
          </CheckoutTitle>
        </Row>
      </SectionContainer>
    </StyledHeader>
  );
};

Header.propTypes = {
  name: PropTypes.string.isRequired,
  logo: PropTypes.shape({
    url: PropTypes.string,
  }),
};

export default Header;
